import { getAge } from 'utils/date'
import { useStores } from './useStores'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'

export function useAgeGroup() {
  const {
    traversal: {
      data: {
        debtors: {
          primary: {
            personal: { birthday }
          }
        }
      }
    }
  } = useStores()

  const debtorsAge = getAge(birthday)
  const ageGroup = getAgeGroupFromAge(debtorsAge)
  return ageGroup
}
